var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper",class:_vm.classObj},[_c('de-container',[_c('de-main-container',{staticClass:"la-main-container"},[_c('app-main')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }